import { Fieldset } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnalyticsAction, logEvent } from "../../../utils/analytics";
import { 
  SearchFilters,
 } from "../../../types/v1_schemas";
 import {
  optionWithId,
  getLookupOptions
} from "../../../utils/lookup";
import FilterCheckbox from "./FilterCheckbox";
import { toggleItemInFilterList } from "../../../utils/filters/shared";

type FeePreferenceInputProps = {
  legend: string;
  compact?: boolean;
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
};

function FeePreferenceInput({
  legend,
  compact = false,
  filters,
  setFilters,
}: FeePreferenceInputProps) {
  const { t } = useTranslation();

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [paymentOptions, setPaymentOptions] = useState(() => getLookupOptions("payment"));

  const setPaymentFilter = (feePreference: optionWithId) => {
    logEvent(AnalyticsAction.UpdateFilter, {
      label: "payment options",
      filter_type: "payment options",
      filter_value: feePreference.lineageText,
    });

    setFilters({
      ...filters,
      paymentTypeIds: toggleItemInFilterList(
        filters.paymentTypeIds as any[], 
        feePreference.id.toString()
      ) as [],
    });
  };

  return (
    <Fieldset legend={legend} legendStyle={compact ? "srOnly" : "large"}>
      {paymentOptions.map((option) => (
        <FilterCheckbox
          name={option.id.toString()}
          value={option.id.toString()}
          label={t(`${option.translate}`)}
          selectedFilterValues={filters.paymentTypeIds ?? []}
          onChange={() => {setPaymentFilter(option);}}
          key={option.id.toString()}
        />
      ))}
    </Fieldset>
  );
}

export default FeePreferenceInput;
